export const Colors = [
  "#F44336",
  "#E1BEE7",
  "#AB47BC",
  "#4A148C",
  "#FBC02D",
  "#3F51B5",
  "#1565C0",
  "#B2EBF2",
  "#00838F",
  "#00E5FF",
  "#1A237E",
  "#00B8D4",
  "#004D40",
  "#F57F17",
  "#A7FFEB",
  "#00BFA5",
  "#2E7D32",
  "#FFF176",
  "#9CCC65",
  "#33691E",
  "#E6EE9C",
  "#9E9D24",
  "#827717",
  "#F9A825",
  "#FFD600",
  "#6D4C41",
  "#BDBDBD",
];
